import { UNTITLED } from "@knowt/syncing/utils/dataCleaning";
import { memo } from "react";
import Image from "next/image";
import { themeColors } from "@/utils/themeColors";
import { getNoteUrl } from "@/utils/url";
import Link from "@/components/wrappers/Link";
import { ASSETS_URL } from "@/config/deployConstants";
import { Note } from "@knowt/syncing/graphql/schema";
import { FlexColumn, FlexRowAlignCenter } from "@/components/Flex";
import { CardRating, ContentPill } from "@/components/cards/UserContentCard/components/UserContentCardBtns";
import { borderRadius } from "@/utils/borderRadius";
import Box from "@mui/material/Box";

const NoteFile = memo(({ note }: { note: Note }) => {
    const { noteId, title: _title, rating, ratingCount, views } = note;

    const title = _title?.trim() || UNTITLED;
    const noteRoute = getNoteUrl({ noteId, title });

    return (
        <Link href={noteRoute} style={{ color: "unset" }} data-testid="auto-id-a183401b-2683-4171-9776-605651d1a37a">
            <Box
                component={FlexColumn}
                sx={{
                    backgroundColor: themeColors.neutralWhite,
                    height: "13rem",
                    padding: "2rem",
                    borderRadius: borderRadius.card,
                    justifyContent: "space-between",
                    border: `1px solid ${themeColors.neutral1}`,
                    "&:hover": {
                        // boxShadow: "inset 0 0 0 10em rgba(0, 0, 0, 0.11)",
                        outline: `1px solid ${themeColors.neutralBlack}`,
                    },
                    "&:active": {
                        // boxShadow: "inset 0 0 0 10em rgba(0, 0, 0, 0.13)",
                        outline: `1px solid ${themeColors.neutralBlack}`,
                    },
                }}>
                <div
                    className="ellipsisText"
                    style={{
                        fontWeight: 700,
                        color: themeColors.neutralBlack,
                    }}
                    data-testid="auto-id-46ce405d-18bf-47bc-a37f-b3c960424c7c">
                    {title}
                </div>
                <FlexRowAlignCenter style={{ gap: "1.5rem" }}>
                    <ContentPill style={{ backgroundColor: "var(--color-docs-light)" }}>
                        <FlexRowAlignCenter as="span" style={{ gap: "0.5rem" }}>
                            <Image src={`${ASSETS_URL}/images/note-icon.svg`} alt="note" width="15" height="15" />
                            {"Note"}
                        </FlexRowAlignCenter>
                    </ContentPill>
                    <ContentPill style={{ backgroundColor: "var(--color-background)" }} className="ellipsisText">
                        <FlexRowAlignCenter>
                            <Image
                                src={`${ASSETS_URL}/images/views-icon.svg`}
                                alt={"studied by"}
                                width={18}
                                height={18}
                                style={{ objectFit: "contain" }}
                            />
                            Studied by {views ?? 0} {(views ?? 0) === 1 ? "person" : "people"}
                        </FlexRowAlignCenter>
                    </ContentPill>
                </FlexRowAlignCenter>
                <CardRating rating={rating} ratingCount={ratingCount} />
            </Box>
        </Link>
    );
});

NoteFile.displayName = "NoteFile";

export default NoteFile;
